enum GLOBAL {
    PUBLIC_URL = "https://tiendaiwari.globoazul.pe",
    // PUBLIC_URL = "http://iwari-app.com",
}

export default GLOBAL;
